/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Product_Category_Code_FormatInputs */

const vi_product_category_code_format = /** @type {(inputs: Product_Category_Code_FormatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mã chỉ gồm chữ in hoa không dấu, số và dấu gạch dưới, không có dấu cách (vd TUI_12_5G), tối đa ${i?.max} ký tự.`)
};

/**

* @param {Product_Category_Code_FormatInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_category_code_format = /** @type {((inputs: Product_Category_Code_FormatInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Category_Code_FormatInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_category_code_format(inputs)
});